module.exports = __webpack_public_path__ + "static/media/avatar3.e93db838.jpg";